import axios from 'axios';

const adhocBackendAPI = 'https://adhocstudio.ca/feed/getCompleteFloorplans.php?id=';
const awsBackendAPI = 'https://aws.adhocstudio.ca/api/floorplans/public/';

export default {
  fetchFromADhoc(projectId) {
    return axios.get(adhocBackendAPI + projectId);
  },
  fetchFromAWS(awsId) {
    return axios.get(awsBackendAPI + awsId);
  },
  downloadFavourites(plans) {
    return axios.post('https://adhocstudio.ca/feed/keeley-app/downloadPlans.php', { plans });
  },
  emailFloorplans(params) {
    return axios.post('https://adhocstudio.ca/dev/email/EmailMultipleFloorplans.php', params)
      .then(() => axios.post('https://adhocstudio.ca/feed/recordEmailFloorplanGlobal.php', params));
  }
};



// WEBPACK FOOTER //
// ./src/services/floorplans.js